import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBlp6PJ5KEezR4gu8IEqrOv2I0uO0Luc9E",
  authDomain: "ppshope-f16f3.firebaseapp.com",
  projectId: "ppshope-f16f3",
  storageBucket: "ppshope-f16f3.appspot.com",
  messagingSenderId: "376894969587",
  appId: "1:376894969587:web:e426cc88b7b67169568986",
  measurementId: "G-NS4W0BZQJX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

const googleProvider = new GoogleAuthProvider();
googleProvider.addScope("email")

export { auth, googleProvider };